import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

const state = {
  navbar: { open: true, sectionId: ""},
  navbarReRender: 0,
  sectionHover: "", // sectionId
  layoutStyle: { open: false, id: ""},
  openStyleFromSection: '',
  selectedPage: null
};

export default {
  state,
  actions,
  getters,
  mutations
};
